import { store } from "@wordpress/interactivity";

const { state } = store("atuka/atuka-nav", {
	state: {
		isScrolled: false,
	},
	actions: {},
	callbacks: {
		handleScroll: function* () {
			state.isScrolled = window.scrollY > 30;
		},
	},
});
